import React from "react";
import {
  Card,
  Typography,
  Box,
  CardMedia,
  Container,
  Grid,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Autoplay, Navigation, Pagination } from "swiper/modules";

const eventsData = [
  {
    id: 1,
    image: "./images/gallery4.jpg",
  },
  {
    id: 2,
    image: "./images/gallery5.jpg",
  },
  {
    id: 3,
    image: "./images/gallery6.jpg",
  },
  {
    id: 4,
    image: "./images/gallery7.jpg",
  },
  {
    id: 5,
    image: "./images/gallery8.jpg",
  },
];

const Gallery = () => {
  return (
    <Box id="gallery" sx={{ my: 5 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Gallery
      </Typography>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation={false}
              pagination={false}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {eventsData.map((event) => (
                <SwiperSlide key={event.id}>
                  <Card style={{ margin: "10px auto" }}>
                    <CardMedia
                      component="img"
                      height="240"
                      image={event.image}
                      alt={event.id}
                    />
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Gallery;
